import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * `<legend-strip>` — engraved labelling strip primitive.
 *
 * Treats panel labelling as discrete data rather than baked-into the chassis
 * SVG. This separation is what allows us to swap labels per language or per
 * configuration without redrawing geometry, and gives Storybook stories a
 * way to vary labelling without forking the chassis.
 */
@customElement('legend-strip')
export class LegendStripElement extends LitElement {
  static override styles = [
    css`
      :host {
        display: inline-flex;
        align-items: center;
        gap: var(--space-sm);
        inline-size: 100%;
        font-family: var(--font-ui);
        color: var(--control-button-engrave);
        font-size: var(--type-tiny);
        text-transform: uppercase;
        letter-spacing: 0.04em;
      }
    `,
  ];

  /** Comma-separated label sequence laid out along the strip. */
  @property({ type: String }) accessor labels = '';

  override render() {
    // TODO(Phase 2): split labels into individual cells with engraving
    // shadow effect honouring the vendor's chassis finish token.
    return html`<span>${this.labels}</span>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'legend-strip': LegendStripElement;
  }
}
